import React, { useState, useEffect } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";

export default function Hex() {
  const [text, setText] = useState("");
  const [code, setCode] = useState("");
  
  const textToCode = (input) => {
    if (!input) return "";
    return input
      .split("")
      .map((char) => char.charCodeAt(0).toString(16).padStart(2, "0"))
      .join(" ");
  };

  const codeToText = (input) => {
    if (!input) return "";
    return input
      .trim()
      .split(" ")
      .map((hx) => String.fromCharCode(parseInt(hx, 16)))
      .join("");
  };

  const formatInput = (input) => {
    input = input.replace(/\s+/g, "");
    const formatted = input.match(/.{1,2}/g) || [];
    return formatted.join(" ");
  };

  const handleTextChange = (e) => {
    let value = e.target.value;
    setText(value);
    textToCode(value);
  };

  const handleCodeChange = (e) => {
    let value = e.target.value.replace(/[^a-zA-Z0-9 ]/g, "").toUpperCase();
    value = formatInput(value);
    setCode(value);
    codeToText(value);
  };

  useEffect(() => {
    if (document.activeElement.name === "text") {
      setCode(textToCode(text));
    } else if (document.activeElement.name === "code") {
      setText(codeToText(code));
    }
  }, [text, code]);

  return (
  <>
    <HelmetProvider>
      <Helmet>
        <title>Hexadecimal | ERI</title>
      </Helmet>
    </HelmetProvider>
    <div id="ciphers" className="content">
      <div id="hex" className="content-wrapper">
        <div className="content-title">
          <h1 className="title">Hexadecimal</h1>
          <p className="subtitle">El sistema hexadecimal es una técnica de numeración que se caracteriza por tener como base el número 16.</p>
        </div>
        <div className="content-main">
          <div className="content-code">
            <div className="content-encrypt">
              <label className="text-left" htmlFor="code">Hexadecimal</label>
              <textarea id="input-code" className="input-left" name="code" value={code} spellCheck="false"
                onChange={handleCodeChange}
              />
              <span className="info info-left">Carácteres permitidos: 0, 1 y espacio</span>
              <div className="buttons">
                <button className="btn btn-primary" onClick={() => setCode(textToCode(text).toUpperCase())}><span>Cifrar </span><i className="fas fa-arrow-right"></i></button>
                <button className="btn btn-primary" onClick={() => setText(codeToText(code))}><i className="fas fa-arrow-left"></i><span> Descrifrar</span></button>
              </div>
              <label className="text-right" htmlFor="text">Texto</label>
              <textarea id="input-text" className="input-right" name="text" value={text} spellCheck="false"
                onChange={handleTextChange}
              />
              <span className="info info-right">Carácteres permitidos: Números, letras y espacio</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
  );
}
